module.exports = "/_next/static/images/macpunks-hero-mobile-d754a51cd15a3b1febc523862bb84332.png";